<div *ngIf="getCampaign" id="modal-login">
  <div
    class="screenBloqe align-items-center"
    style="justify-items: center"
    [ngClass]="{
      'd-none': screenBloqued == false,
      'd-grid': screenBloqued == true,
    }"
  >
    <img
      [defaultImage]="env.S3_STATIC_FILES + '/images/web/gif-load-refresh.svg'"
      [lazyLoad]="getCampaign.base_gif_load"
      width="70px"
      alt=""
    />
  </div>
  <div class="modal-body px-3 px-md-3" style="opacity: {{ opacityLoadOTP }} ">
    <div class="content-modal-theme">
      <div class="container-fluid px-0" id="">
        <div id="modalBody">
          <div class="btn-close-login">
            <button
              (click)="activeModal.dismiss()"
              class="btn-home-hover position-absolute fw-bold text-white bg-transparent close-modal-login"
              *ngIf="!disable_modal_step_notificacion_components"
            >
              <i class="bi bi-x-lg text-black"></i>
            </button>
          </div>
          <div class="col-12 px-md-3 px-1 pt-5 pb-3 text-center">
            <i class="mi mi-md-lg {{ iconAuth }}"></i>
            <h2 class="fw-bolder fs-4 mt-3" [innerHTML]="titleHeader"></h2>
            <p class="mt-3 mb-2 auth-description" [innerHTML]="descriptionLogin"></p>

            <form autocomplete="on" method="POST" [formGroup]="Form_OTP" class="mt-2" (keyup.enter)="loginForm()">
              <div
                id="alert-msg"
                class="alert-message text-start col-12 mt-3 mb-0"
                *ngIf="messageAlert.message && resp_conn_between_component.data.hide_alert != true"
                [ngClass]="{
                  'alert-error': messageAlert.error === 401 || messageAlert.error === 404,
                  'alert-info': messageAlert.error === 500,
                }"
              >
                <span [innerHTML]="messageAlert.message"></span>
                <span *ngIf="messageAlert.error == 404">
                  <a (click)="returnSignUp()" class="fw-bold cursor-pointer text-danger">desde aqui</a>
                </span>
              </div>

              <div class="pt-2" *ngIf="[201, 401, 500].includes(statusSigIN)">
                <p class="mb-0 text-red-100 text-center text-size-sm">
                  @switch (statusSigIN) {
                    @case (201) {
                      <b>Has excedido el límite de intentos</b><br />
                      Por favor, reenvía el código
                    }
                    @case (401) {
                      <b>Código incorrecto</b><br />
                      El código que ingresaste es incorrecto. Te queda <b>un intento más</b>.
                    }
                    @case (500) {
                      <b>No fue posible enviar el código</b> <br />
                      por favor intenta más tarde.
                    }
                  }
                </p>
              </div>

              <div class="position-relative pt-3 pb-4 pb-md-4 px-md-3 px-1" *ngIf="controlFormSiginUp">
                <app-input-phone-international
                  [submitted]="submitted"
                  [forceIsRequired]="true"
                  (inputPhoneInternational_Emit)="EmiteinputPhoneInternational($event)"
                >
                </app-input-phone-international>
              </div>

              <div class="px-md-3 px-1 pt-3" *ngIf="controlFormSendCode">
                <p class="text-center text-secondary text-size-nl">
                  ¿El número es incorrecto?,
                  <span class="cursor-pointer text-blue-100" (click)="updatedSigUpElement()">Actualízalo aquí.</span>
                </p>

                <app-input-otp [submitted]="submitted" (InputOTP_Emit)="EmiteinputOTP($event)"> </app-input-otp>

                <div class="d-flex mt-3 text-size-sm">
                  <div class="col-7 text-start text-blue-100">
                    <span
                      class="{{ resendClassEnabled }}"
                      (click)="
                        resendCode({
                          phone: cookies.get('phone-number'),
                          prefix_phone: cookies.get('phone-prefix'),
                          status: resendStatusCode,
                          call_code: false,
                        })
                      "
                      >Reenviar código:
                    </span>
                  </div>
                  <div class="col-5 text-end">
                    <b>{{ getFormattedTime() }}</b>
                  </div>
                </div>

                <p
                  class="link-hidd mt-0 text-size-sm text-start {{ resendClassEnabled }}"
                  *ngIf="env.BRAND == 'mcdt'"
                  (click)="
                    resendCode({
                      phone: cookies.get('phone-number'),
                      prefix_phone: cookies.get('phone-prefix'),
                      status: resendStatusCode,
                      call_code: true,
                    })
                  "
                >
                  ¿No recibiste un código?
                  <b class="{{ resendClassEnabled }} text-blue-100">Recíbelo en una llamada</b>
                </p>
              </div>

              <div *ngIf="controlRegisterUser">
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  placeholder="Escribe tu nombre"
                  class="form-control entry-field-icon border-field"
                  formControlName="fullname"
                  [ngClass]="{
                    'is-invalid': submitted && f['fullname'].errors,
                    'is-valid': f['fullname'].errors === null,
                  }"
                />

                <div
                  class="invalid-feedback color-error"
                  [ngClass]="{
                    'd-block': submitted && f['fullname'].errors,
                    'd-none': f['fullname'].errors === null,
                  }"
                >
                  El nombre debe tener almenos 3 carácteres
                </div>
              </div>

              <button
                *ngIf="!controlFormSendCode"
                id="botonEnviarDatos"
                type="button"
                class="btn btn-lg border-1 border-blue-100 text-blue-100 bg-hover-blue-100 text-hover-white rounded-pill col-11 col-md-10"
                (click)="loginForm()"
              >
                {{ titleButton }}
              </button>
            </form>

            <p class="mt-5 mb-0 text-size-nl text-secondary">
              ¿Algún problema?
              @if (env.BRAND == 'coltefinanciera') {
                <a
                  href="https://api.whatsapp.com/message/FHJFAPESCA2NG1?autoload=1&app_absent=0"
                  target="_blank"
                  class="text-decoration-none text-blue-100"
                  >Escríbenos aquí</a
                >
              } @else {
                <a
                  href="https://api.whatsapp.com/send?phone=573160234714&text=Hola,%20estoy%20tratando%20de%20continuar%20con%20mi%20proceso%20de%20CDT%20y%20no%20estoy%20recibiendo%20el%20C%C3%B3digo%20de%20verificaci%C3%B3n%20en%20mi%20celular"
                  target="_blank"
                  class="text-decoration-none text-blue-100"
                  >Escríbenos aquí</a
                >
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
